import { injectable } from "inversify-props";
import { CashbackCrmBonusServiceAdapter } from "@/usecases/cliente/adapter/CashbackCrmBonusServiceAdapter";
import { possuiPluginCrmBonusConfigurado, enviarPINParaCliente, 
	reenviarPINParaCliente, validarPINInformado, consultaCashbackCrmBonusCliente, 
	consultarCampanhasDisponiveisCrmBonus, finalizarVendaCashbackCrmBonus, enviarVendaCrmBonus,
	cancelarCrmBonus, validarToken, consultarCashbackDisponivelDoClienteNoCrm, possuiPluginConsultaCrmBonusConfigurado} from "@/api/cashbackCrmBonus";

@injectable()
export class CashbackCrmBonusService implements CashbackCrmBonusServiceAdapter {
	possuiPluginCrmBonusConfigurado = async (lojaId: string) => await possuiPluginCrmBonusConfigurado(lojaId)

	validarToken = async (lojaId: string) => await validarToken(lojaId)

	enviarPINParaCliente = async (cnpjOuCpfCliente: string, lojaId: string, valor: number, itens: any) => await enviarPINParaCliente(cnpjOuCpfCliente, lojaId, valor, itens)

	reenviarPINParaCliente = async (cnpjOuCpfCliente: string, params: any) => await reenviarPINParaCliente(cnpjOuCpfCliente, params)

	validarPINInformado = async (params: any, pin: string, vendaId: string) => await validarPINInformado(params, pin, vendaId)

	consultaCashbackCrmBonusCliente = async (userId: string, requestHash: string, lojaId: string, valor: number, params: any) => await consultaCashbackCrmBonusCliente(userId, requestHash, lojaId, valor, params)

	consultarCampanhasDisponiveisCrmBonus = async (params: any) => await consultarCampanhasDisponiveisCrmBonus(params)

	finalizarVendaCashbackCrmBonus = async (params: any, campanhaId: string, pinMaster: boolean) => await finalizarVendaCashbackCrmBonus(params, campanhaId, pinMaster)

	enviarVendaCrmBonus = async (params: any) => await enviarVendaCrmBonus(params)

	cancelarCrmBonus = async (vendaId: string, lojaId: string) => await cancelarCrmBonus(vendaId, lojaId)

	consultarCashbackDisponivelDoClienteNoCrm = async (lojaId: string, cnpjOuCpfCliente: string) => await consultarCashbackDisponivelDoClienteNoCrm(lojaId, cnpjOuCpfCliente)

	possuiPluginConsultaCrmBonusConfigurado = async (lojaId: string) => await possuiPluginConsultaCrmBonusConfigurado(lojaId)
}